import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Button from '~/components/Button'
import SVG from '~/components/SVG'
import { formatNumber, universalDispatch } from '~/utils'
import { unfollowActivity, followActivity } from '~/services'
import plusIcon from '~/assets/icon-plus.svg'
import styles from './index.css'

export default class ActivityInfo extends Component {
  constructor(props) {
    super(props)
    const { activityFollowed = 2 } = props
    this.state = {
      activityFollowed: activityFollowed === 1,
    }
  }

  handleClick = () => {
    const { activityFollowed } = this.state
    const { id } = this.props
    const updateActivityFollowedStatus = activityFollowed
      ? unfollowActivity
      : followActivity

    universalDispatch(() => {
      updateActivityFollowedStatus({ id }).then(() => {
        this.setState({ activityFollowed: !activityFollowed })
      })
    })
  }

  render() {
    const { title, browse, follow } = this.props
    const { activityFollowed } = this.state

    return (
      <div className={styles.activityInfo}>
        <Helmet title={title} />
        <div>
          <header className={styles.activityTitle}>{title}</header>
          <span className={styles.activitySubtitle}>
            {`${formatNumber(browse)}浏览 · ${formatNumber(follow)}人关注`}
          </span>
        </div>
        {activityFollowed ? (
          <Button
            className={styles.activityFollowButton}
            onClick={this.handleClick}
            color="grey"
          >
            已关注
          </Button>
        ) : (
          <Button
            className={styles.activityFollowButton}
            onClick={this.handleClick}
          >
            <div>
              <SVG src={plusIcon} width={12} height={12} />
            </div>
            <div>关注</div>
          </Button>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/ActivityInfo/index.js